import React, { FC, ChangeEvent } from 'react';
import { FooterLinkModel } from '../../../../models/footerLink.model';
import { TFooterLink } from '../../../../types/footerLink.types';
import { windowService } from '../../../../utils/window.utils';
import './styles.scss';
import Icon from '../../../@shared/icon';
import { iconSize } from '../../../../constants/icon.constants';

const LanguageSelector: FC<TFooterLink> = (props) => {
  const model = new FooterLinkModel(props);

  const redirectToTargetUrl = (url): void => {
    const urlIsValid = !!model?.list?.find(item => item?.fields?.link?.value?.href === url);

    if (urlIsValid) {
      windowService().location.assign(url);
    }
  };

  const onChange = (evt: ChangeEvent<HTMLSelectElement>): void => redirectToTargetUrl(evt?.target?.value);
  const options = model?.list.map((item) => (
    <option key={item?.id} value={item?.fields?.link?.value?.href}>
      {item?.fields?.link?.value?.text}
    </option>
  ));

  return (
    <div className="language-selector">
      <Icon iconName="action-flag" size={iconSize.mbl} extraClassName="language-selector__left-icon" />
      <select className="language-selector__select" onChange={onChange} aria-label="Language Selector">
        {options}
      </select>
      <Icon iconName="arrow-chevron-down" size={iconSize.mbl} extraClassName="language-selector__right-icon" />
    </div>
  );
};

export default LanguageSelector;
